import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog';
import { toggleEnabledWithEntity } from '../Redux/Actions.js';
import { getAppEnabled } from '../../../../Resources/Organization/Apps/AppsData.js';
import ActionToggle from '../ActionToggle';

const GenericAppButton = ({ app, name, url }) => {
  const appEnabled = useSelector(getAppEnabled(app));
  const buttonColor = useSelector((state) => state.buttonColor);
  const buttonText = useSelector((state) => state.buttonText.toUpperCase());
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();

  const onToggleAppEnabled = () => dispatch(toggleEnabledWithEntity(app));

  const onSwitchChange = (event, checked) => {
    if (checked) {
      setDialogOpen(true);
      return Promise.resolve(true);
    }

    return onToggleAppEnabled();
  };

  const onCloseDialog = useCallback(() => setDialogOpen(false), []);

  const onConnectAccountClick = useCallback(() => {
    setDialogOpen(false);
    onToggleAppEnabled();
    window.open(url, '_blank');
  }, []);

  return (
    <>
      <ActionToggle
        enabled={appEnabled}
        hideToggle={false}
        onClick={onSwitchChange}
        buttonColor={buttonColor}
        buttonText={buttonText}
        canUseApp
      />
      <ConfirmationDialog
        open={dialogOpen}
        title={`Connect to ${name}`}
        onClose={onCloseDialog}
        leftButton={<Button onClick={onCloseDialog}>Cancel</Button>}
        rightButton={(
          <Button color="primary" onClick={onConnectAccountClick}>
            Connect account
          </Button>
        )}
      >
        <Typography paragraph>
          You’re almost done. Sign up or login to your {name}
          {' '}
          account now to enable the integration.
        </Typography>
      </ConfirmationDialog>
    </>
  );
};

export default GenericAppButton;
